@let cosmetics = cosmetics$ | async;

<div class="grid items-center lg:grid-cols-12">
  <div class="text-gray-500 lg:col-span-8 xl:col-span-9">
    <div class="mb-4">
      W ofercie marki znajduje się {{ cosmeticsLength() }} kosmetyków.
    </div>
  </div>

  <div class="lg:col-span-4 xl:col-span-3">
    <app-public-brand-cosmetic-sort-panel
      (sortTypeChange)="handleSortTypeChange($event)" />
  </div>
</div>

@if (cosmetics) {
  <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
    @for (cosmetic of cosmetics; track cosmetic.id) {
      <app-public-brand-cosmetics-tile
        [boxes]="cosmetic.boxes"
        [image]="cosmetic.featuredFile"
        [name]="cosmetic.name"
        [slug]="cosmetic.slug" />
    }
  </div>
} @else {
  <div class="flex min-h-72 w-full items-center justify-center">
    <app-spinner-filled />
  </div>
}
